// extracted by mini-css-extract-plugin
module.exports = {"light_ui-form-label-color":"#1d2333","dark_ui-form-label-color":"#fff"};